import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

type Props = {
  color: TailwindColor
  text: string
}

const Legend = ({ color, text }: Props) => {
  return (
    <div className="flex items-center gap-1">
      <Badge color={color} className="rounded-full h-3 w-3 p-0" />
      <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
        {text}
      </Typography>
    </div>
  )
}

export default Legend
